import ReactModal from "react-modal";

export interface Props {
  isOpen: Boolean;
  children: any;
}

const Modal = ({ isOpen, children }: Props) => {
  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        overlay: {
          position: "fixed",
          zIndex: 1020,
          top: 0,
          left: 0,
          background: "rgba(255, 255, 255, 0.75)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          inset: 0,
          padding: 0,
          background: "white",
          overflowY: "auto",
          position: "relative",
          border: "1px solid #ccc",
          borderRadius: "0.3rem",
        },
      }}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
